import React from 'react';
import {
	FireScreenAnalytics,
	ContextualAnalyticsData,
	DRAWER,
} from '@atlassian/jira-product-analytics-bridge';
import { SidebarDataHandler } from '../../common/async-handler/index.tsx';
import { FIELD_LIMIT } from '../../common/constants.tsx';
import { useSelectFieldStatistics } from '../../services/select-field/index.tsx';
import { DonutChart } from './donut-chart/index.tsx';

type Props = {
	customFieldId: string;
	query: string;
	width: number;
};

export const DonutChartContainer = ({ customFieldId, query, width }: Props) => {
	const [{ loading, data, error }] = useSelectFieldStatistics({
		customFieldId,
		query,
		limit: FIELD_LIMIT,
	});

	return (
		<SidebarDataHandler error={error} loading={loading} data={data} isEmpty={data?.length === 0}>
			<ContextualAnalyticsData
				sourceType={DRAWER}
				sourceName="jira.issueFieldStatistics.donutChart"
			>
				<FireScreenAnalytics />
				{data && <DonutChart data={data} width={width} />}
			</ContextualAnalyticsData>
		</SidebarDataHandler>
	);
};
